import { render, staticRenderFns } from "./AffiliateLinksModal.vue?vue&type=template&id=04dd0b30&scoped=true"
import script from "./AffiliateLinksModal.vue?vue&type=script&lang=js"
export * from "./AffiliateLinksModal.vue?vue&type=script&lang=js"
import style0 from "./AffiliateLinksModal.vue?vue&type=style&index=0&id=04dd0b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dd0b30",
  null
  
)

export default component.exports